import classNames from 'classnames';
import { FC, ReactElement, useMemo, MouseEvent } from 'react';
import { localeStore } from 'src/mobx/localesStore';
import './style.scss';

interface IProps {
  type?: 'checkbox' | 'radio';
  value?: boolean;
  name: string | number;
  onClick: (name: string | number, value: boolean | undefined) => void;
  appearance?: 'circle' | 'square';
  label?: string | number;
  disabled?: boolean;
  error?: boolean;
  className?: string;
  inputClassName?: string;
  labelClassName?: string;
}

export const Checkbox: FC<IProps> = ({
  type = 'checkbox',
  value = false,
  appearance = type === 'radio' ? 'circle' : 'square',
  ...props
}: IProps): ReactElement => {
  const onClick = () => {
    if (props.disabled) return;
    props.onClick(props.name, value);
  };

  const onClickLabel = (event: MouseEvent<HTMLLabelElement>) => {
    event.preventDefault();
    onClick();
  };

  const wrapperClassName = useMemo((): string => {
    return classNames('checkbox__wrapper', props.className, { disabled: props.disabled });
  }, [props.className, props.disabled]);

  const className = useMemo((): string => {
    const typeClassName: string = `checkbox_${appearance}`;
    return classNames('checkbox', typeClassName, props.inputClassName, { 'input-error': props.error });
  }, [appearance, props.inputClassName, props.error]);

  const id = useMemo((): string => (props.name ? String(props.name) : type), [type, props.name]);

  return (
    <div className={wrapperClassName}>
      <input id={id} type={type} checked={value} onChange={onClick} className={className} />
      {props.label ? (
        <label htmlFor={id} onClick={onClickLabel} className={classNames('checkbox__label pl-3', props.labelClassName)}>
          {typeof props.label === 'string' ? localeStore.t(props.label) : props.label}
        </label>
      ) : null}
    </div>
  );
};
